export const ORDER_INTERNAL_ORDER_STATUS_LIST = ([
    // ['0', { en: 'Incomplete', vi: 'Chưa hoàn thành' }],
    // ['1', { en: 'Completed', vi: 'Đã hoàn thành' }],
    // ['2', { en: 'Closed', vi: 'Đã đóng' }],
    // ['3', { en: 'Exception', vi: 'Bất thường' }],
    { label: 'constant.status.incomplete', value: 0 },
    { label: 'constant.status.completed', value: 1 },
    { label: 'constant.status.closed', value: 2 },
    { label: 'constant.status.exception', value: 3 },
  ]);
  
  export const ORDER_INTERNAL_PAYMENT_STATUS_LIST = ([
    // [0, { label: 'Unpaid', value: 'Chưa thanh toán' }],
    // [1, { label: 'Paid', value: 'Đã thanh toán' }],
    { label: 'constant.status.unpaid', value: 0 },
    { label: 'constant.status.paid', value: 1 },
  ]);
  
  /** SendStatus (deliveryStatus) – string values align with backend SendStatus. */
export const ORDER_INTERNAL_DELIVER_STATUS_LIST: { label: string; value: string }[] = [
  { label: 'constant.status.initial', value: '30510' },
  { label: 'constant.status.item_send_initial', value: '20510' },
  { label: 'constant.status.item_line_send_initial', value: '10510' },
  { label: 'constant.status.packed', value: '40510' },
  { label: 'constant.status.out_of_stock', value: '50510' },
  { label: 'constant.status.seller_cancel', value: '60510' },
  { label: 'constant.status.buyer_cancel', value: '70510' },
  { label: 'constant.status.system_cancel', value: '80510' },
  { label: 'constant.status.ready_to_ship_pending', value: '10511' },
  { label: 'constant.status.ready_to_ship', value: '10512' },
  { label: 'constant.status.shipped', value: '10513' },
  { label: 'constant.status.failed_delivery', value: '10514' },
  { label: 'constant.status.all_pending_delivery', value: '30511' },
  { label: 'constant.status.all_delivered_successfully', value: '30512' },
  { label: 'constant.status.all_delivery_failed', value: '30513' },
  { label: 'constant.status.partial_delivery', value: '30514' },
  { label: 'constant.status.awaiting_retry', value: '30528' },
  { label: 'constant.status.return_stock_success', value: '30529' },
];

/** ReceivingStatus – string values align with backend ReceivingStatus. */
export const ORDER_INTERNAL_RECEIVING_STATUS_LIST: { label: string; value: string }[] = [
  { label: 'constant.status.initial', value: '30520' },
  { label: 'constant.status.item_receiving_initial', value: '20520' },
  { label: 'constant.status.item_line_receiving_initial', value: '10520' },
  { label: 'constant.status.delivered', value: '10521' },
  { label: 'constant.status.confirmed', value: '10522' },
  { label: 'constant.status.returned', value: '10523' },
  { label: 'constant.status.lost_by_3pl', value: '10524' },
  { label: 'constant.status.damaged_by_3pl', value: '10525' },
  { label: 'constant.status.pending_receipt', value: '30521' },
  { label: 'constant.status.fully_received', value: '30522' },
  { label: 'constant.status.partially_received', value: '30523' },
  { label: 'constant.status.awaiting_retry', value: '30528' },
  { label: 'constant.status.return_stock_success', value: '30529' },
];

  export const ORDER_INTERNAL_PICKUP_METHOD_LIST = ([
    { label: 'constant.status.pickup', value: 'STORE_PICKUP' },
    { label: 'constant.status.delivery', value: 'SHIP_TO_ADDRESS' },
  ]);

  export const ORDER_INTERNAL_PAYMENT_METHOD_LIST = ([
    { label: 'o2o.create.form.options.cash', value: 'cash' },
    { label: 'o2o.create.form.options.wallet', value: 'wallet' },
    { label: 'o2o.create.form.options.card', value: 'card' },
  ]);